import { maskedChain } from '../lib/chains'

// /retailers is proxied to Rails and never bundled, so inside the shell a
// root-relative src resolves against https://localhost and every logo 404s.
const API_BASE = import.meta.env.VITE_API_URL || ''

// Retailer logo, or an anonymised initial chip when masked mode is on.
//
// The chip mirrors design/og-results-shot.mjs — a coloured tile with a white
// initial, deliberately not a brand colour or a fake logo. `index` is the row's
// position in the rendered list, which on the results page is price rank, so the
// cheapest row always chips as "K" / Košara.
export default function ChainLogo({ chain, index = 0, masked = false, size = 'h-12 w-12', shape = 'rounded' }) {
  if (masked) {
    const { letter, bg } = maskedChain(index)
    return (
      <div
        data-testid="mask-chip"
        aria-hidden="true"
        className={`${size} ${shape} shrink-0 flex items-center justify-center font-extrabold text-white leading-none`}
        style={{ backgroundColor: bg }}
      >
        {letter}
      </div>
    )
  }

  return (
    <div className={`${size} ${shape} shrink-0 overflow-hidden bg-surface flex items-center justify-center`}>
      <img
        src={`${API_BASE}/retailers/${chain}.jpg`}
        alt=""
        loading="lazy"
        className="h-full w-full object-contain"
        onError={(e) => {
          e.currentTarget.style.display = 'none'
        }}
      />
    </div>
  )
}
